import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-trash-svg-icon',
  imports: [NgClass],
  templateUrl: './trash-svg-icon.component.html',
  styleUrl: './trash-svg-icon.component.css',
})
export class TrashSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#577778';
}
